/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { NewPlan } from '../model/newPlan';

@Injectable()
export class CreatePlanService {
    private countryURL: string = environment.host + '/country';
    private createPlanURL: string = environment.host + '/plan';
    // Model to hold Plan periods in 'Calendar' step & use them in 'Volumes' step
    public planPeriods = [];
    public planId = '';

    constructor(private http: HttpClient) { }

    public reset() {
        this.planPeriods = [];
        this.planId = '';
    }

    public getAllCountries() {
        return this.http.get(this.countryURL.toString()).toPromise();
    }

    public createPlan(newPlan: NewPlan) {
        return this.http.post(this.createPlanURL.toString(), newPlan).toPromise();
    }

    public updatePlan(newPlan: NewPlan) {
        return this.http.put(this.createPlanURL.toString() + "/" + newPlan.id, newPlan).toPromise();
    }

    public updatePlanStatus(newPlan: NewPlan) {
        return this.http.put(this.createPlanURL.toString() + "/" + newPlan.id + "/status", newPlan).toPromise();
    }
}
